import { render, staticRenderFns } from "./PromoWeekPromo.vue?vue&type=template&id=7484085a&scoped=true"
import script from "./PromoWeekPromo.vue?vue&type=script&lang=js"
export * from "./PromoWeekPromo.vue?vue&type=script&lang=js"
import style0 from "./PromoWeekPromo.vue?vue&type=style&index=0&id=7484085a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7484085a",
  null
  
)

export default component.exports